export default __webpack_public_path__ + "static/media/line.a1ee4b92.svg";